// React
import { useEffect, useState, useCallback } from 'react';
import { useLocation } from "react-router";
import FilePreview from "react-preview-file";
import { useHistory } from "react-router-dom";
import { Dialog } from '@progress/kendo-react-dialogs';

// Kendo
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import { Upload } from "@progress/kendo-react-upload";
import { Button } from '@progress/kendo-react-buttons';

// Css
import styles from './userDetail_mobile.module.css';
import "./userDetail_mobile.css";

// Service
import { getFile, setPlacePhoto1, setPlacePhoto2, setUserPhoto } from "../../../service/mngt/elderService";
import { useRef } from 'react';

//component


const ChangePhotoMobile = ({ conn }) => {
 
  const locationState = useLocation().state;
  const history = useHistory();

  const [completeDialogVisible, setCompleteDialogVisible] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("사진을 등록해주세요.");
  const closeCompleteDialog = () => {
    setCompleteDialogVisible(false);
  }

  const [dataState, setDataState] = useState({
    userId: locationState.dataState.userId,
    fileIdUserPhoto: "",
    fileIdPlacePhoto1: "",
    fileIdPlacePhoto2: "",
    fileIdPlacePhoto3: "",
  });

  const [filesState, setFilesState] = useState({
    filesUserPhoto: [],
    fileInfoUserPhoto: [],
    fileIdUserPhoto: "",
    filesPlacePhoto1: [],
    fileInfoPlacePhoto1: [],
    fileIdPlacePhoto1: "",
    filesPlacePhoto2: [],
    fileInfoPlacePhoto2: [],
    fileIdPlacePhoto2: "",
  });
  const [imgFile, setImgFile] = useState({
    imgFileUserPhoto: "",
    imgFilePlacePhoto1: "",
    imgFilePlacePhoto2: "",
    imgFilePlacePhoto3: "",
  });
  //사진 등록 시 미리보기
  const [previewFile, setPreviewFile] = useState({
    previewFileUserPhoto: "",
    previewFilePlacePhoto1: "",
    previewFilePlacePhoto2: "",
    previewFilePlacePhoto3: "",
  });

  const onAdd = e => {
    if(e.target.props.name === "userPhoto") {
      setPreviewFile((previewFile) => {
        const item =  { ...previewFile };
        item.previewFileUserPhoto = e.affectedFiles[0]
        return item;
      });
      setFilesState(state => {
        const item = { ...state };
        item.filesUserPhoto = e.newState;
        item.fileInfoUserPhoto = encodeURI(JSON.stringify(e.affectedFiles));
        return item;
      });
    } else if(e.target.props.name === "placePhoto1") {
      setPreviewFile((previewFile) => {
        const item =  { ...previewFile };
        item.previewFilePlacePhoto1 = e.affectedFiles[0]
        return item;
      });
      setFilesState(state => {
        const item = { ...state };
        item.filesPlacePhoto1 = e.newState;
        item.fileInfoPlacePhoto1 = encodeURI(JSON.stringify(e.affectedFiles));
        return item;
      });
    } else if(e.target.props.name === "placePhoto2") {
      setPreviewFile((previewFile) => {
        const item =  { ...previewFile };
        item.previewFilePlacePhoto2 = e.affectedFiles[0]
        return item;
      });
      setFilesState(state => {
        const item = { ...state };
        item.filesPlacePhoto2 = e.newState;
        item.fileInfoPlacePhoto2 = encodeURI(JSON.stringify(e.affectedFiles));
        return item;
      });
    } else if(e.target.props.name === "placePhoto3") {

    }

    console.log("onAdd", e.affectedFiles);

  };

  const onRemove = useCallback(

  );

  const onProgress = e => {
    const { affectedFiles, serverResponse } = e;
    console.log("onProgress.affectedFiles", affectedFiles);
    console.log("onProgress.serverResponse", serverResponse);

    setFilesState(state => {
      const item = { ...state };
      item.filesUserPhoto = e.newState;
      return item;
    });
  };

  const onStatusChangeUserPhoto = e => {
    
    //수정 버튼 클릭 시
    if (e.response !== undefined) {
      const { fileId } = e.response.response.data[0];

      setDataState((dataState) => {
        const item = { ...dataState };
        item.fileIdUserPhoto = fileId;
        // setUserPhoto(conn, item);
        return item;
      })

    }

    setFilesState(state => {
      const item = { ...state };
      item.filesUserPhoto = e.newState;
      return item;
    });
  }

  const onStatusChangePlacePhoto1 = e => {

    if (e.response !== undefined) {
      const { fileId } = e.response.response.data[0];
      // setDataState({ ...dataState, fileIdUserPhoto });
      // dataState.fileIdUserPhoto = fileId;
      setDataState((dataState) => {
        const item = { ...dataState };
        item.fileIdPlacePhoto1 = fileId;       
        // setPlacePhoto1(conn, item);
        return item;
      })
    }

    setFilesState(state => {
      const item = { ...state };
      item.filesPlacePhoto1 = e.newState;
      return item;
    });
  }
 
  const onStatusChangePlacePhoto2 = e => {

    if (e.response !== undefined) {
      const { fileId } = e.response.response.data[0];
      // setDataState({ ...dataState, fileIdUserPhoto });
      // dataState.fileIdUserPhoto = fileId;
      setDataState((dataState) => {
        const item = { ...dataState };
        item.fileIdPlacePhoto2 = fileId;       
        // setPlacePhoto2(conn, item);
        return item;
      })
    }

    setFilesState(state => {
      const item = { ...state };
      item.filesPlacePhoto2 = e.newState;
      return item;
    });
  } 

  const [photoExist, setPhotoExist] = useState({
    userPhoto: false,
    placePhoto1: false,
    placePhoto2: false,
  })
  const handleSubmit = (e) => {
    
    if(dataState.fileIdUserPhoto) {
      setUserPhoto(conn, dataState);
      setPhotoExist((photoExist) => {
        const item = { ...photoExist };
        item.userPhoto = true;
        return item;
      })
    } else {
      setPhotoExist((photoExist) => {
        const item = { ...photoExist };
        item.userPhoto = true;
        return item;
      })
    }

    if(dataState.fileIdPlacePhoto1) {
      setPlacePhoto1(conn, dataState);
      setPhotoExist((photoExist) => {
        const item = { ...photoExist };
        item.placePhoto1 = true;
        return item;
      })
    } else {
      setPhotoExist((photoExist) => {
        const item = { ...photoExist };
        item.placePhoto1 = true;
        return item;
      })
    }

    if(dataState.fileIdPlacePhoto2) {
      setPlacePhoto2(conn, dataState);
      setPhotoExist((photoExist) => {
        const item = { ...photoExist };
        item.placePhoto2 = true;
        return item;
      })
    } else {
      setPhotoExist((photoExist) => {
        const item = { ...photoExist };
        item.placePhoto2 = true;
        return item;
      })
    }

    if(!dataState.fileIdUserPhoto && !dataState.fileIdPlacePhoto1 && !dataState.fileIdPlacePhoto2) {
      setCompleteDialogVisible(true);
    }

  }
  
  const isFirstRender = useRef(true);
  const goUserInfo = () => {
    const userId = dataState.userId;
    history.push({
      pathname: "/user/info",
      state: { userId },
    });
  }
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      if(!dataState.fileIdUserPhoto && !dataState.fileIdPlacePhoto1 && !dataState.fileIdPlacePhoto2) {
        setCompleteDialogVisible(true);
      } else {
        setDialogMessage("저장을 완료하였습니다.")
        setCompleteDialogVisible(true);
        goUserInfo();
      }
    }
  }, [photoExist.userPhoto && photoExist.placePhoto1 && photoExist.placePhoto2]);

  const userPhoto = () => {
    getFile(conn, locationState.dataState.fileIdUserPhoto)
    .then(fileResponse => {
      const dataUri = 'data:image/png;base64,' + fileResponse;
      setImgFile((imgFile) => {
        const item = { ...imgFile};
        item.imgFileUserPhoto = dataUri;
        return item;
      });
    })
    .catch(err => {
      console.log("getFile err = ", err);
    })
    getFile(conn, locationState.dataState.fileIdPlacePhoto1)
    .then(fileResponse => {
      const dataUri = 'data:image/png;base64,' + fileResponse;
      setImgFile((imgFile) => {
        const item = { ...imgFile};
        item.imgFilePlacePhoto1 = dataUri;
        return item;
      });
    })
    .catch(err => {
      console.log("getFile err = ", err);
    })
    getFile(conn, locationState.dataState.fileIdPlacePhoto2)
    .then(fileResponse => {
      const dataUri = 'data:image/png;base64,' + fileResponse;
      setImgFile((imgFile) => {
        const item = { ...imgFile};
        item.imgFilePlacePhoto2 = dataUri;
        return item;
      });
    })
    .catch(err => {
      console.log("getFile err = ", err);
    })
  }

  useEffect(() => {
    userPhoto();
  },[])

  return (
    <>
      <div className="pageContent_m">
        <div className="userInfoDetail">
          <div className={styles.changePhotoBox}>
            <div className={styles.photoTitle}>대상자 사진</div>
            <div className={styles.photoContent}>
              <div className={styles.photo}>
                {!previewFile.previewFileUserPhoto ? (
                  imgFile.imgFileUserPhoto ? (
                    <img className={styles.img} src={imgFile.imgFileUserPhoto} alt="사진" />
                  ) : (
                    <img className={styles.img} src="/images/mobile/photo.png" alt="사진" />
                  )
                ) : (
                  <FilePreview file={previewFile.previewFileUserPhoto.getRawFile()}>{preview => <img className={styles.img} src={preview} />}</FilePreview>
                )}
              </div>
              <LocalizationProvider language="ko-KR">
                <IntlProvider locale="ko">
                  <Upload
                    name="userPhoto"
                    className="fileUpload"
                    showFileList={false}
                    autoUpload={false}
                    batch={true}
                    multiple={false}
                    files={filesState.filesUserPhoto}
                    defaultFiles={[]}
                    onAdd={onAdd}
                    onRemove={onRemove}
                    onProgress={onProgress}
                    onStatusChange={onStatusChangeUserPhoto}
                    withCredentials={true}
                    removeVerb={"DELETE"}
                    restrictions={{
                      allowedExtensions: [".jpg", ".png"],
                      maxFileSize: 10240000,
                    }}
                    saveMethod={"post"}
                    saveHeaders={{
                      "Content-Type": "multipart/form-data",
                      "X-AUTH-TOKEN": localStorage.getItem(`${process.env.REACT_APP_TOKEN}`),
                    }}
                    saveUrl={"/api/v2.2/file/upload?fileInfo=" + filesState.fileInfoUserPhoto}
                    removeUrl={"/file/delete"}
                  />
                </IntlProvider>
              </LocalizationProvider>
            </div>
          </div>
          <div className={styles.changePhotoBox}>
            <div className={styles.photoTitle}>현장 사진 1</div>
            <div className={styles.photoContent}>
              <div className={styles.photo}>
                {!previewFile.previewFilePlacePhoto1 ? (
                  imgFile.imgFilePlacePhoto1 ? (
                    <img className={styles.img} src={imgFile.imgFilePlacePhoto1} alt="사진" />
                  ) : (
                    <img className={styles.img} src="/images/mobile/photo.png" alt="사진" />
                  )
                ) : (
                  <FilePreview file={previewFile.previewFilePlacePhoto1.getRawFile()}>{preview => <img className={styles.img} src={preview} />}</FilePreview>
                )}
              </div>
              <LocalizationProvider language="ko-KR">
                <IntlProvider locale="ko">
                  <Upload
                    name="placePhoto1"
                    className="fileUpload"
                    showFileList={false}
                    autoUpload={false}
                    batch={true}
                    multiple={false}
                    files={filesState.filesPlacePhoto1}
                    defaultFiles={[]}
                    onAdd={onAdd}
                    onRemove={onRemove}
                    onProgress={onProgress}
                    onStatusChange={onStatusChangePlacePhoto1}
                    withCredentials={true}
                    removeVerb={"DELETE"}
                    restrictions={{
                      allowedExtensions: [".jpg", ".png"],
                      maxFileSize: 10240000,
                    }}
                    saveMethod={"post"}
                    saveHeaders={{
                      "Content-Type": "multipart/form-data",
                      "X-AUTH-TOKEN": localStorage.getItem(`${process.env.REACT_APP_TOKEN}`),
                    }}
                    saveUrl={"/api/v2.2/file/upload?fileInfo=" + filesState.fileInfoPlacePhoto1}
                    removeUrl={"/file/delete"}
                  />
                </IntlProvider>
              </LocalizationProvider>
            </div>
          </div>
          <div className={styles.changePhotoBox}>
            <div className={styles.photoTitle}>현장 사진 2</div>
            <div className={styles.photoContent}>
              <div className={styles.photo}>
                {!previewFile.previewFilePlacePhoto2 ? (
                  imgFile.imgFilePlacePhoto2 ? (
                    <img className={styles.img} src={imgFile.imgFilePlacePhoto2} alt="사진" />
                  ) : (
                    <img className={styles.img} src="/images/mobile/photo.png" alt="사진" />
                  )
                ) : (
                  <FilePreview file={previewFile.previewFilePlacePhoto2.getRawFile()}>{preview => <img className={styles.img} src={preview} />}</FilePreview>
                )}
              </div>
              <LocalizationProvider language="ko-KR">
                <IntlProvider locale="ko">
                  <Upload
                    name="placePhoto2"
                    className="fileUpload"
                    showFileList={false}
                    autoUpload={false}
                    batch={true}
                    multiple={false}
                    files={filesState.filesPlacePhoto2}
                    defaultFiles={[]}
                    onAdd={onAdd}
                    onRemove={onRemove}
                    onProgress={onProgress}
                    onStatusChange={onStatusChangePlacePhoto2}
                    withCredentials={true}
                    removeVerb={"DELETE"}
                    restrictions={{
                      allowedExtensions: [".jpg", ".png"],
                      maxFileSize: 10240000,
                    }}
                    saveMethod={"post"}
                    saveHeaders={{
                      "Content-Type": "multipart/form-data",
                      "X-AUTH-TOKEN": localStorage.getItem(`${process.env.REACT_APP_TOKEN}`),
                    }}
                    saveUrl={"/api/v2.2/file/upload?fileInfo=" + filesState.fileInfoPlacePhoto2}
                    removeUrl={"/file/delete"}
                  />
                </IntlProvider>
              </LocalizationProvider>
            </div>
          </div>
            <div className={styles.info}>
              <Button className={styles.addButton} onClick={handleSubmit}>사진 저장</Button>
            </div>
        </div>
      </div>
      {completeDialogVisible && (
        <Dialog
          className="completeDialog"
          width={"90vw"}
          height={"40vw"}
          closeIcon={false}
        >
          <p>
            {dialogMessage}
            <br></br>
            <button onClick={closeCompleteDialog}>확인</button>
          </p>
        </Dialog>
      )}
    </>
  );
};
export default ChangePhotoMobile;
